import React from 'react'
import PropTypes from 'prop-types'

import BuyerProfilesWrapper from 'agency/digital_renderer/components/BuyerProfilesWrapper'
import TextOnly from '../TextOnly'
import styles from './styles.scss'

const profileDescriptions = {
  BUILDER_RENOVATOR:
    'These buyers are looking for opportunities to enhance the existing property by updating certain features and/or looking to add to size and amenity to the home.',
  DEVELOPER:
    'With major cities expanding and embracing apartment living, this has opened up a very strong buyer pool of developers looking for potential multi unit sites of 2 or more dwellings, or more substantial sites for multi unit development.',
  DOWNSIZER:
    'These buyers are looking for a low-maintenance, convenient home with close proximity to the CBD, shops and lifestyle amenities.',
  FAMILY:
    'Currently one of the most active buyer pools, this group looks for close proximity to schools, the CBD, shops and lifestyle attractions. This is a strong buyer group with limited stock to choose from.',
  FIFO_WORKER:
    'These buyers are looking for a property to lock up and leave. They don’t want to worry about big gardens, and usually prefer extra security.',
  FIRST_HOME_BUYER:
    'We guide ﬁrst home buyers through the entire process of buying their ﬁrst home, from deposit through to searching, settling and moving in. ',
  INTERNATIONAL_BUYER:
    'An increasingly active buyer pool, international purchasers and expatriates look for strong rental return, solid capital growth and close proximity to shops, public transport and modern lifestyle conveniences.',
  INVESTOR:
    'The Agency Projects affords buyers access to off-the-plan sales and exciting new developments. With our experienced team marketing projects across Australia, we present buyers with a pathway to exceptional investment opportunities.',
  PROFESSIONAL_COUPLE:
    'Characterised by limited stock to select from, this very active buyer pool looks for convenience to the CBD, shops and other modern lifestyle conveniences.',
  REGIONAL_BUYER:
    'These buyers are currently residing in regional areas and are looking to secure a base in the city and would consider modifying an existing home.',
}

const renderProfiles = buyerProfiles => buyerProfiles.map((profile) => {
  const profileDescription = profileDescriptions[profile.key]

  if (profileDescription){
    return (
      <span key={profile.key} className={styles.profile}>
        <span className={styles.profileTitle}>{profile.title}</span>

        <span className={styles.profileDescription}>{profileDescription}</span>
      </span>
    )
  }

  return null
})

const BuyerProfiles = ({ campaign }) => {
  const campaignData = campaign.data || {}
  const profileKeys = campaignData.buyer_profiles || []

  if (!profileKeys.length) return null

  return (
    <BuyerProfilesWrapper
      campaign={campaign}
      render={({ buyerProfiles }) => (
        <TextOnly
          title="Buyer profiles"
          text={(
            <div className={styles.root}>
              <span>
                The Agency has excellent relationships with buyers across the full spectrum of target markets. Each
                buyer group is categorised in our comprehensive buyer database, which is constantly updated with
                information gathered at open homes, regular follow-ups and communication. Buyers are kept informed of
                all current relevant stock meeting their buying criteria and are consistently providing us with
                constructive feedback that we can then report back to you.
                <br />
                <br />
                Based on our assessment of your property and current buyer trends, we believe that your property will
                appeal most to the following categories of buyers:
              </span>
              {renderProfiles(buyerProfiles)}
            </div>
)}
        />
      )}
    />
  )
}

BuyerProfiles.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default BuyerProfiles
